import React, {FC} from 'react'
import {ServiceRequestModal} from '../../../../../components/ServiceResquests/Modal'
import {Input} from '../../../../../components/Input/Input'
import {Button} from '../../../../../components/Button/Button'
import {i18n} from '../../../../../translate/i18n'

interface QuantityModalProps {
  isOpen: boolean
  maxQuantity: number
  onQuantityChange: (value: string) => void
  onClose: () => void
  onConfirm: () => void
}

const QuantityModal: FC<QuantityModalProps> = ({
  isOpen,
  maxQuantity,
  onQuantityChange,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null

  return (
    <ServiceRequestModal
      onCloseAction={onClose}
      title={i18n.t('service_requests.max_quantity_modal_title')}
      width='400px'
    >
      <div>
        <div className='mb-4'>
          <Input
            inputAttr={{
              type: 'number',
              min: '1',
              max: '999',
            }}
            label={i18n.t('service_requests.max_quantity_label')}
            value={maxQuantity.toString()}
            change={onQuantityChange}
            placeholder={i18n.t('service_requests.max_quantity_placeholder')}
          />
          <div className='form-text text-muted mt-2'>
            {i18n.t('service_requests.max_quantity_helper')}
          </div>
        </div>

        {/* Botões de ação */}
        <div className='d-flex justify-content-end gap-2'>
          <Button
            text={i18n.t('service_requests.cancel_button')}
            color='danger'
            size='small'
            btnAttr={{type: 'button'}}
            click={onClose}
          />
          <Button
            text={i18n.t('service_requests.confirm_button')}
            color='primary'
            size='small'
            btnAttr={{type: 'button'}}
            click={onConfirm}
            disabled={maxQuantity < 1}
          />
        </div>
      </div>
    </ServiceRequestModal>
  )
}

export {QuantityModal}
